import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'normalize.css/normalize.css' // 样式重置

Vue.config.productionTip = false

// 移动端适配 start
const setHtmlFontSize = () => {
    const htmlDom = document.getElementsByTagName('html')[0];
    let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    if (htmlWidth >= 750) {
        htmlWidth = 750;
    }
    if (htmlWidth <= 320) {
        htmlWidth = 320;
    }
    htmlDom.style.fontSize = `${htmlWidth / 7.5}px`;
};
window.onresize = setHtmlFontSize;
setHtmlFontSize();
// 移动端适配 end

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
